module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/currency-3ac5713af2fca288798b8e0600e17922.png";